export default "__VITE_ASSET__D$ILe3eh__"